<template>
    <el-container style="height: 100vh; border: 1px solid #eee">
        <el-header style="width:100%;height: 60px;position:fixed;top:0;z-index: 99999;">
            <!--<b class="logo" @click="toHome">超进化物语后台管理</b>-->

            <i class="menu-icon" :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'" @click="isCollapse = !isCollapse"></i>
            <b class="logo" @click="toHome">{{globalConfigYunwei.consoleName}}</b>

            <div style="float: right;margin-left: 10px;">
                <el-dropdown trigger="click" @command="handleFunMenu">
                    <el-button type="danger" circle icon="el-icon-user-solid"></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="modifyPassword">修改密码</el-dropdown-item>
                        <el-dropdown-item command="loginOut">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <span class="name">{{ user.name }}</span>
            <span class="lang">
                <el-dropdown @command="changeLang" trigger="click">
                    <span class="el-dropdown-link">
                        {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in langType" :key="index" :command="index">{{item.label}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>

            <!--<span class="time-zone">-->
                <!--<el-dropdown @command="changeTimeZone" trigger="click">-->
                    <!--<span class="el-dropdown-link">-->
                        <!--{{timeZone}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                    <!--</span>-->
                    <!--<el-dropdown-menu slot="dropdown">-->
                        <!--<el-dropdown-item v-for="(item, index) in timeZoneData" :key="index" :command="index">{{item.label}}</el-dropdown-item>-->
                    <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
            <!--</span>-->

            <span class="version-number">版本号:{{globalConfig.version}}</span>

            <span class="local-time">UTC-5:{{serverDateFormatStr}} {{serverTime}}</span>
            <span class="local-time">UTC8:{{localDateFormatStr}} {{localTime}}</span>
        </el-header>

        <el-dialog :visible.sync="funMenuShow" title="修改密码" width="33%" lock-scroll center>
            <div style="text-align: center;">
                <el-form :label-position="'right'" label-width="90px" :model="modifyPassForm">
                    <el-form-item label='旧密码'>
                        <el-input v-model="modifyPassForm.oldPassword"></el-input>
                    </el-form-item>
                    <el-form-item label='新密码'>
                        <el-input v-model="modifyPassForm.newPassword" show-password></el-input>
                    </el-form-item>
                    <el-form-item label='确认新密码'>
                        <el-input v-model="newPasswordConfirm" show-password></el-input>
                    </el-form-item>
                </el-form>

                <el-button style="width: 200px;" type="primary" size="medium" @click="modifyPassword">修改密码</el-button>
            </div>
        </el-dialog>

        <el-container style="margin-top: 60px;">
            <el-aside :width="isCollapse?'':'220px'">
                <el-autocomplete
                    class="inline-input"
                    v-model="menuValue"
                    :fetch-suggestions="querySearchMenu"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    v-if="!isCollapse"
                >
                    <template slot-scope="{ item }">
                        <span class="addr">{{item.meta.title}}</span>
                    </template>
                    <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                </el-autocomplete>
                <el-menu class="el-menu-vertical-demo" :collapse="isCollapse" :unique-opened="true" background-color="#343957" text-color="#fff" :style="isCollapse?'height: 100%;':'height: 120%;'">
                    <sub-menu
                        v-for="menu in menuList"
                        :key="menu.id"
                        :menu="menu"
                        :dynamicMenuRoutes="dynamicMenuRoutes">
                    </sub-menu>
                </el-menu>
            </el-aside>
            <el-main>
                <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 50px;">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <template v-for="(route, index) in routes">
                        <el-breadcrumb-item v-if="route.meta.title" :key="index">
                            <router-link :to="{ path: route.path }" v-if="index < routes.length - 1">
                                {{ route.meta.title }}
                            </router-link>
                            <span v-else>{{ route.meta.title }}</span>
                        </el-breadcrumb-item>
                    </template>
                </el-breadcrumb>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import {
        mapState
    } from 'vuex';
    import Utils from '../lib/utils'
    import accountApi from '../service/account_api'
    import actionConfirm from '../mixins/action_confirm'

    import SubMenu from '../components/sub_menu'
    import router from './../router'

    export default {
        name: "master",
        data() {
            return {
                globalConfig: Global_Config,
                globalConfigYunwei: Global_Config_Yunwei,
                serverZoneTime: Global_Config_Yunwei.serverZoneTime,
                activeNames: [],

                worldTitle: '',
                gameTitle: '',

                lang: '',

                menuList: [],
                dynamicMenuRoutes: [],

                menuValue: '',

                funMenuShow: false,
                modifyPassForm: {
                    oldPassword: '',
                    newPassword: ''
                },

                newPasswordConfirm: '',
                isCollapse: false,

                timeZone: '东八区',
                timeZoneData: [
                    {
                        value: 8,
                        label: '东八区'
                    },
                    {
                        value: -5,
                        label: '西五区'
                    }
                ],
                localTime: '',
                localDateFormatStr: '',
                serverTime: '',
                serverDateFormatStr: '',
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.userInfo,
                permissions: state => state.user.permissions,
                token: state => state.user.userInfo.loginToken
            }),

            routes() {
                return this.$route.matched.slice();
            },

        },
        mixins: [actionConfirm],
        created() {
            this.setEast8Time();
            setInterval(this.setEast8Time, 1000);
            this.setWest5Time();
            setInterval(this.setWest5Time, 1000);

            this.worldTitle = '选择世界区';
            this.gameTitle = '选择游戏服';
            // this.lang = this.langType[0].label;
            // this.getLangs();

            this.menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
            this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
        },
        mounted() {
            let self = this;
            self.getLangs();
            setTimeout(()=> {
                self.lang = self.langType.length>0?self.langType[0].label:'';
                self.$i18n.locale = self.langType[0].value?self.langType[0].value:'hant';
                Utils.setCookie('lang',self.$i18n.locale);
            },2000)

            // let timeZoneValue = Utils.getCookie('timeZone')?Utils.getCookie('timeZone'):'8';
            // self.timeZoneData.forEach(item => {
            //     if (timeZoneValue == item.value) {
            //         self.timeZone = item.label;
            //     }
            // })
        },
        components: {
            SubMenu
        },
        methods: {
            setEast8Time() {
                var date = new Date();
                var date2 = '';
                date2 = this.toEast8Time(date);

                var mon = date2.getMonth() + 1;
                var day = date2.getDate();
                var hours = date2.getHours();
                var minutes = date2.getMinutes();
                var seconds = date2.getSeconds();
                this.localTime = Utils.padLeft(hours, 2) + ":" + Utils.padLeft(minutes, 2) + ":" + Utils.padLeft(seconds, 2);
                this.localDateFormatStr = date2.getFullYear() + "/" + Utils.padLeft(mon, 2) + "/" + Utils.padLeft(day, 2);
            },

            setWest5Time() {
                var date = new Date();
                var date2 = '';
                date2 = this.toWest5Time(date);

                var mon = date2.getMonth() + 1;
                var day = date2.getDate();
                var hours = date2.getHours();
                var minutes = date2.getMinutes();
                var seconds = date2.getSeconds();
                this.serverTime = Utils.padLeft(hours, 2) + ":" + Utils.padLeft(minutes, 2) + ":" + Utils.padLeft(seconds, 2);
                this.serverDateFormatStr = date2.getFullYear() + "/" + Utils.padLeft(mon, 2) + "/" + Utils.padLeft(day, 2);
            },

            querySearchMenu(queryString, cb) {
                var menus = this.dynamicMenuRoutes;
                var results = queryString ? menus.filter(this.createFilter(queryString)) : menus;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (menus) => {
                    return (menus.meta.title.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },

            handleSelect(item) {
                this.$router.push({
                    path: '/' + item.path
                });
                this.menuValue = item.meta.title
            },

            // 切换语言
            changeLang(command) {
                let self = this;
                let conf = self.langType[command];
                self.$i18n.locale = conf.value;
                self.lang = conf.label;
                Utils.setCookie('lang',conf.value)
            },

            // 切换时区
            changeTimeZone(command) {
                let self = this;
                let conf = self.timeZoneData[command];
                self.timeZone = conf.label;
                Utils.setCookie('timeZone',conf.value);
            },

            // 功能菜单(退出/修改密码)
            handleFunMenu(command) {
                if (command == 'loginOut') {
                    this.loginOut();
                } else if (command == 'modifyPassword') {
                    this.showFunMenu();
                }
            },
            // 功能菜单展示
            showFunMenu() {
                this.funMenuShow = true;
                this.modifyPassForm = {
                    oldPassword: '',
                    newPassword: ''
                };
                this.newPasswordConfirm = '';
            },

            //退出
            loginOut() {
                router.options.isAddDynamicMenuRoutes = false;
                sessionStorage.setItem('menuList', '[]');
                Utils.delCookie('user');
                Utils.delCookie('permissions');
                this.$store.commit("SET_USERINFO", ''); //更新登录状态
                this.$router.push({
                    path: '/login'
                });
            },

            // 跳转首页
            toHome() {
                this.$router.push({
                    path: '/home'
                });
            },

            // 用户修改密码
            modifyPassword() {
                var data = this.modifyPassForm;
                if (data.newPassword !== this.newPasswordConfirm) {
                    this.$message({
                        type: 'warning',
                        message: '密码不一致，请重新输入'
                    });
                    return;
                }

                accountApi.changePassword({
                    token: this.token,
                    modifyPassForm: data
                }).then(res => {
                    this.funMenuShow = false;
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    this.loginOut();
                })
            }
        }
    }
</script>

<style lang="less">
    .el-collapse-item__header {
        background-color: #f56c6c !important;
        text-align: center !important;
        display: block !important;
        color: #FFFFFF !important;
        width: 100% !important;
    }

    .el-collapse-item__content {
        padding-left: 50px !important;
    }

    .el-submenu .el-menu-item {
        min-width: 199px !important;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>

<style scoped lang="less">
    .el-header {
        background-color: #343957;
        color: #eee;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
    }

    .logo {
        float: left;
        cursor: pointer;
    }

    .name {
        float: right;
        font-weight: bold;
    }

    .lang {
        float: right;
        margin-right: 10px;
    }

    .time-zone {
        float: right;
        margin-right: 10px;
    }

    .version-number {
        font-size: 10px;
        float: right;
        margin-right: 10px;
    }

    .inline-input {
        width: 100%;
    }

    .menu-icon {
        float: left;
        line-height: 60px;
        margin-right: 20px;
        font-size: 30px;
        cursor: pointer;
    }

    .local-time {
        float: right;
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/master.vue